export default __webpack_public_path__ + "static/GT-America-Standard-Regular-a2ba3058e32c388c9848937fc0045b52.woff";